import Route from '@ember/routing/route';
import type PublicTransition from '@ember/routing/transition';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';
import { ModelName } from 'webapp/enums/enums';

export default class SettingsUsersRoute extends Route {
	@service('store') declare storeService: Service.Store;
	@service('model-manager/users') declare mmUsersService: Service.ModelManager.Users;
	@service('account') declare accountService: Service.Account;
	@service('navigation') declare navigationService: Service.Navigation;

	override beforeModel(transition: PublicTransition) {
		if (this.accountService.isDemoAccount) {
			this.navigationService.transitionToRoute('index');
		}
		// check for invite reminder id, sent as param in inviterUserReminder email
		const uid = transition.to?.queryParams.uid as string;
		if (uid && this.storeService.peekRecord(ModelName.USER, uid)) {
			this.mmUsersService.sendUserInviteReminder(uid);
		}
	}
}
